import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { CEContext } from '../../types';
import { PropertyOption, PropertyTypes } from '@gspwidget/widget-devkit';
import { WidgetPropertyService } from '@gspwidget/widget-core';

@Component({
  selector: 'ce-array',
  templateUrl: './ce-array.component.html'
})
export class CeArrayComponent implements OnInit {

  prop: PropertyOption
  valueArray: any[]
  @Input() set propAndValue (v: { prop: PropertyOption, value: any[] }) {
    this.prop = v.prop
    if (!Array.isArray(v.value)) {
      this.valueArray = []
      this.onChangeValue.emit(this.valueArray)
    } else {
      this.valueArray = v.value
    }
  }
  @Input() context: CEContext

  readonly PropertyTypes = PropertyTypes

  constructor (
    private widgetProperty: WidgetPropertyService
  ) { }

  ngOnInit () {
  }
  /** å¦æä¸å ï¼ce item å®ä¾ä¼æ··ä¹±ï¼ä» color picker åç°çãå¶ä»ç±»åæå¾æµè¯ */
  TrackByFn = (i, item) => i + item

  @Output() onChangeValue = new EventEmitter()
  handleChangeValueItem (index: number, newValue) {
    this.valueArray[index] = newValue
    this.onChangeValue.emit(this.valueArray.slice())
  }
  handleAddValueItem () {
    const newVal = this.widgetProperty.getPropertyDefaultValue(this.prop, true)
    this.valueArray.push(newVal)
    this.onChangeValue.emit(this.valueArray.slice())
  }
  handleRemoveValueItem (index: number) {
    this.valueArray.splice(index, 1)
    this.onChangeValue.emit(this.valueArray.slice())
  }

}
